const defaultState = {
    pages: [],
    sections: [],
    fields: [],
    options: [],
    settings: {}
};

export const UPDATE_ALL_FORM_DATA = 'formData/UPDATE_ALL_FORM_DATA';

export const updateAllFormData = formData => ({
    type: UPDATE_ALL_FORM_DATA,
    payload: formData
});

export const refreshFormData = formData => dispatch => {
    dispatch(updateAllFormData(formData));
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_ALL_FORM_DATA:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

export default reducer;
